import React, { useState, useEffect, Fragment, useRef } from "react";
import {
    Box, Card, Button, makeStyles, Container, Divider, CardContent, CardHeader,
    Grid, TextField, MenuItem, InputLabel, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TablePagination, Paper,
    Typography
} from "@material-ui/core";
import Page from 'src/components/Page';
import services from "../Services";
import { useNavigate } from "react-router-dom";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import * as Yup from "yup";
import { LoadingComponent } from 'src/utils/newLoader';
import { Formik } from "formik";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { useAlert } from "react-alert";
import xlsx from "json-as-xlsx";
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3),
    },
    colorRecord: {
        backgroundColor: "green",
        color: "white",
    },
    colorCancel: {
        backgroundColor: "red",
        color: "white",
    },
}));

const screenCode = 'ARREARSREPORT';

export default function ArrearsDataReport() {
    const [title] = useState("Arrears Report");
    const classes = useStyles();
    const alert = useAlert();
    const navigate = useNavigate();
    const componentRef = useRef();
    const [groups, setGroups] = useState({});
    const [factories, setFactories] = useState({});
    const [routes, setRoutes] = useState({});
    const [arrearsReportData, setArrearsReportData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [arrearsReportInput, setArrearsReportInput] = useState({
        groupID: 0,
        factoryID: 0,
        routeID: 0,
        month: (new Date().getUTCMonth() + 1).toString().padStart(2, "0"),
        year: new Date().getUTCFullYear().toString(),
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        GroupName: "",
        FactoryName: "",
        RouteName: "",
        Month: "",
        Year: ""
    });
    const [grandTotal, setGrandTotal] = useState({
        totalNetWeight: 0,
        totalGrossPay: 0,
        totalAddition: 0,
        totalBroughtForwardDept: 0,
        totalFertBroughtForward: 0,
        totalFAdv: 0,
        totalAdvance: 0,
        totalTeaBagTotalSpent: 0,
        totalFertilizerTotalSpent: 0,
        totalChemicalTotalSpent: 0,
        totalMealTotalSpent: 0,
        totalLoan: 0,
        totalOther: 0,
        totalTotalDeduction: 0,
        totalArrears: 0
    });

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermission());
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropDown());
    }, [arrearsReportInput.groupID]);

    useEffect(() => {
        trackPromise(getRoutesByFactoryID());
    }, [arrearsReportInput.factoryID]);

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode === 'VIEWARREARSREPORT');
        if (!isAuthorized) navigate('/404');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode === 'FACTORYDROPDOWN');
        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: !!isGroupFilterEnabled,
            isFactoryFilterEnabled: !!isFactoryFilterEnabled
        });
        setArrearsReportInput({
            ...arrearsReportInput,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken()),
        });
    }

    async function getGroupsForDropdown() {
        const data = await services.getAllGroups();
        setGroups(data);
    }

    async function getFactoriesForDropDown() {
        const data = await services.getFactoriesByGroupID(arrearsReportInput.groupID);
        setFactories(data);
    }

    async function getRoutesByFactoryID() {
        const data = await services.getRoutesForDropDown(arrearsReportInput.factoryID);
        setRoutes(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        if (target.name === 'groupID') {
            setArrearsReportInput({
                ...arrearsReportInput,
                [e.target.name]: value,
                factoryID: 0,
                routeID: 0
            });
        } else if (target.name === 'factoryID') {
            setArrearsReportInput({
                ...arrearsReportInput,
                [e.target.name]: value,
                routeID: 0
            });
        }
        else {
            setArrearsReportInput({
                ...arrearsReportInput,
                [e.target.name]: value
            });
        }
        setArrearsReportData([]);
    }

    function handleDateChange(date) {
        let month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
        let year = date.getUTCFullYear().toString();
        setSelectedDate(date);
        setArrearsReportInput({ ...arrearsReportInput, month, year });
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        const monthName = monthNames[parseInt(searchForm.month, 10) - 1];
        const year = searchForm.year;

        setSelectedSearchValues({
            ...selectedSearchValues,
            GroupName: groups[searchForm.groupID],
            FactoryName: factories[searchForm.factoryID],
            RouteName: searchForm.routeID != 0 ? routes[searchForm.routeID] : "All Routes",
            Month: monthName,
            Year: year
        });
    }


    async function handleSearch() {
        setArrearsReportData([]);
        getSelectedDropdownValuesForReport(arrearsReportInput)
        const response = await services.CheckISBalancePaymentCompleted(arrearsReportInput.groupID, arrearsReportInput.factoryID);
        const scheduleParts = response.data.lastBalancePaymentSchedule?.split('/') || [];
        if (response.data.lastBalancePaymentSchedule != null && `${arrearsReportInput.year}${arrearsReportInput.month}` <= `${scheduleParts[0]}${scheduleParts[1]}`) {
            trackPromise(GetArrearsReportDetailsList());
        } else {
            trackPromise(fetchBalanceEstimation());
        }
    }

    async function GetArrearsReportDetailsList() {
        const model = {
            GroupID: parseInt(arrearsReportInput.groupID),
            FactoryID: parseInt(arrearsReportInput.factoryID),
            RouteID: parseInt(arrearsReportInput.routeID),
            ApplicableMonth: arrearsReportInput.month,
            ApplicableYear: arrearsReportInput.year,
        };
        const response = await services.GetArrearsDetails(model);
        if (response.statusCode === "Success") {
            if (response.data != null && response.data.length > 0) {
                setArrearsReportData(response.data);
                calTotal(response.data);
            } else {
                alert.error("No Records Found.")
            }
        }
    }

    async function fetchBalanceEstimation() {
        let model = {
            GroupID: parseInt(arrearsReportInput.groupID),
            FactoryID: parseInt(arrearsReportInput.factoryID),
            RouteID: parseInt(arrearsReportInput.routeID),
            ApplicableMonth: arrearsReportInput.month,
            ApplicableYear: arrearsReportInput.year,
            CollectionTypeBalanceRates: [],
            IsBalancePaymentCalculated: false,
        };
        const response = await services.GetBalancePaymentEstimationBeforeBalanncePayementRun(model);
        if (response.statusCode === "Success") {
            if (response.data != null && response.data.length > 0) {
                setArrearsReportData(response.data);
                calTotal(response.data);
            } else {
                alert.error("No Records Found.")
            }
        } else {
            alert.error(response.message);
        }
    }

    async function calTotal(data) {
        const totalNetWeight = data.reduce((sum, d) => sum + Number(d.netWeight || 0), 0);
        const totalGrossPay = data.reduce((sum, d) => sum + Number(d.grossPay || 0), 0);
        const totalAddition = data.reduce((sum, d) => sum + Number(d.addition || 0), 0);
        const totalBroughtForwardDept = data.reduce((sum, d) => sum + Number(d.broughtForwardDept || 0), 0);
        const totalFertBroughtForward = data.reduce((sum, d) => sum + Number(d.fertBroughtForward || 0), 0);
        const totalFAdv = data.reduce((sum, d) => sum + Number(d.fAdv || 0), 0);
        const totalAdvance = data.reduce((sum, d) => sum + Number(d.advance || 0), 0);
        const totalTeaBagTotalSpent = data.reduce((sum, d) => sum + Number(d.teaBagTotalSpent || 0), 0);
        const totalFertilizerTotalSpent = data.reduce((sum, d) => sum + Number(d.fertilizerTotalSpent || 0), 0);
        const totalChemicalTotalSpent = data.reduce((sum, d) => sum + Number(d.chemicalTotalSpent || 0), 0);
        const totalMealTotalSpent = data.reduce((sum, d) => sum + Number(d.mealDeduction || 0), 0);
        const totalLoan = data.reduce((sum, d) => sum + Number(d.loan || 0), 0);
        const totalOther = data.reduce((sum, d) => sum + Number(d.other || 0), 0);
        const totalTotalDeduction = data.reduce((sum, d) => sum + Number(d.totalDeduction || 0), 0);
        const totalArrears = data.reduce((sum, d) => sum + Number(d.arrears || 0), 0);
        setGrandTotal({
            totalNetWeight: totalNetWeight,
            totalGrossPay: totalGrossPay,
            totalAddition: totalAddition,
            totalBroughtForwardDept: totalBroughtForwardDept,
            totalFertBroughtForward: totalFertBroughtForward,
            totalFAdv: totalFAdv,
            totalAdvance: totalAdvance,
            totalTeaBagTotalSpent: totalTeaBagTotalSpent,
            totalFertilizerTotalSpent: totalFertilizerTotalSpent,
            totalChemicalTotalSpent: totalChemicalTotalSpent,
            totalMealTotalSpent: totalMealTotalSpent,
            totalLoan: totalLoan,
            totalOther: totalOther,
            totalTotalDeduction: totalTotalDeduction,
            totalArrears: totalArrears
        })
    }

    async function createDataForExcel(data) {
        const res = [];
        const routeIDs = getUniqueRouteIDs(data);
        let vr = {
            "": "",
            "SupplierID": "",
            "SupplierName": "",
            "NetWeight": "",
            "GrossPay": "",
            "Addition": "",
            "B/F Debt": "",
            "Fert B/F": "",
            "FAdv    ": "",
            "Advance ": "",
            "Tea     ": "",
            "Fertilizer": "",
            "Chemical": "",
            "Meal    ": "",
            "Loan    ": "",
            "Other   ": "",
            "TotalDeduction": "",
            "Arrears ": ""
        }
        routeIDs.sort((a, b) => routes[a].localeCompare(routes[b])).forEach(routeID => {
            const routeData = data.filter(d => d.routeID === routeID);
            const totalNetWeight = routeData.reduce((s, d) => s + Number(d.netWeight || 0), 0);
            const totalGrossPay = routeData.reduce((s, d) => s + Number(d.grossPay || 0), 0);
            const totalAddition = routeData.reduce((s, d) => s + Number(d.addition || 0), 0);
            const totalBroughtForwardDept = routeData.reduce((s, d) => s + Number(d.broughtForwardDept || 0), 0);
            const totalFertBroughtForward = routeData.reduce((s, d) => s + Number(d.fertBroughtForward || 0), 0);
            const totalFAdv = routeData.reduce((s, d) => s + Number(d.fAdv || 0), 0);
            const totalAdvance = routeData.reduce((s, d) => s + Number(d.advance || 0), 0);
            const totalTea = routeData.reduce((s, d) => s + Number(d.teaBagTotalSpent || 0), 0);
            const totalFertilizer = routeData.reduce((s, d) => s + Number(d.fertilizerTotalSpent || 0), 0);
            const totalChemical = routeData.reduce((s, d) => s + Number(d.chemicalTotalSpent || 0), 0);
            const totalMeal = routeData.reduce((s, d) => s + Number(d.mealDeduction || 0), 0);
            const totalLoan = routeData.reduce((s, d) => s + Number(d.loan || 0), 0);
            const totalOther = routeData.reduce((s, d) => s + Number(d.other || 0), 0);
            const totalDeduction = routeData.reduce((s, d) => s + Number(d.totalDeduction || 0), 0);
            const totalArrears = routeData.reduce((s, d) => s + Number(d.arrears || 0), 0);
            res.push(vr);
            res.push({
                "": "Route: " + routes[routeID],
                "SupplierID": "",
                "SupplierName": "",
                "NetWeight": "",
                "GrossPay": "",
                "Addition": "",
                "B/F Debt": "",
                "Fert B/F": "",
                "FAdv    ": "",
                "Advance ": "",
                "Tea     ": "",
                "Fertilizer": "",
                "Chemical": "",
                "Meal    ": "",
                "Loan    ": "",
                "Other   ": "",
                "TotalDeduction": "",
                "Arrears ": "",
            });
            routeData.forEach(d => {
                res.push({
                    "SupplierID": d.registrationNumber || "",
                    "SupplierName": d.name || "",
                    "NetWeight": Number(d.netWeight || 0),
                    "GrossPay": Number(d.grossPay || 0),
                    "Addition": Number(d.addition || 0),
                    "B/F Debt": Number(d.broughtForwardDept || 0),
                    "Fert B/F": Number(d.fertBroughtForward || 0),
                    "FAdv    ": Number(d.fAdv || 0),
                    "Advance ": Number(d.advance || 0),
                    "Tea     ": Number(d.teaBagTotalSpent || 0),
                    "Fertilizer": Number(d.fertilizerTotalSpent || 0),
                    "Chemical": Number(d.chemicalTotalSpent || 0),
                    "Meal    ": Number(d.mealDeduction || 0),
                    "Loan    ": Number(d.loan || 0),
                    "Other   ": Number(d.other || 0),
                    "TotalDeduction": Number(d.totalDeduction || 0),
                    "Arrears ": Number(Math.abs(d.arrears) || 0),
                });
            });
            res.push({
                "": "Total :",
                "SupplierID": "",
                "NetWeight": Number(totalNetWeight),
                "GrossPay": Number(totalGrossPay),
                "Addition": Number(totalAddition),
                "B/F Debt": Number(totalBroughtForwardDept),
                "Fert B/F": Number(totalFertBroughtForward),
                "FAdv    ": Number(totalFAdv),
                "Advance ": Number(totalAdvance),
                "Tea     ": Number(totalTea),
                "Fertilizer": Number(totalFertilizer),
                "Chemical": Number(totalChemical),
                "Meal    ": Number(totalMeal),
                "Loan    ": Number(totalLoan),
                "Other   ": Number(totalOther),
                "TotalDeduction": Number(totalDeduction),
                "Arrears ": Number(Math.abs(totalArrears)),
            });
        });
        res.push(vr);
        res.push({
                "": "Grand Total :",
                "SupplierID": "",
                "NetWeight": Number(grandTotal.totalNetWeight),
                "GrossPay": Number(grandTotal.totalGrossPay),
                "Addition": Number(grandTotal.totalAddition),
                "B/F Debt": Number(grandTotal.totalBroughtForwardDept),
                "Fert B/F": Number(grandTotal.totalFertBroughtForward),
                "FAdv    ": Number(grandTotal.totalFAdv),
                "Advance ": Number(grandTotal.totalAdvance),
                "Tea     ": Number(grandTotal.totalTeaBagTotalSpent),
                "Fertilizer": Number(grandTotal.totalFertilizerTotalSpent),
                "Chemical": Number(grandTotal.totalChemicalTotalSpent),
                "Meal    ": Number(grandTotal.totalMealTotalSpent),
                "Loan    ": Number(grandTotal.totalLoan),
                "Other   ": Number(grandTotal.totalOther),
                "TotalDeduction": Number(grandTotal.totalTotalDeduction),
                "Arrears ": Number(Math.abs(grandTotal.totalArrears)),
            });
        res.push(vr);
        res.push({
            "": "Group: " + selectedSearchValues.GroupName,
            "SupplierID": "Factory: " + selectedSearchValues.FactoryName,
        });
        res.push({
            "": "Route: " + selectedSearchValues.RouteName,
            "SupplierID": "Month: " + selectedSearchValues.Month + ' ' + selectedSearchValues.Year,
        });
        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(arrearsReportData);
        var settings = {
            sheetName: 'BL Arrears Report',
            fileName: 'BL Arrears Report' + ' - ' + selectedSearchValues.GroupName + ' - ' + selectedSearchValues.FactoryName + ' - ' + selectedSearchValues.RouteName
                + ' - ' + selectedSearchValues.Month + ' ' + selectedSearchValues.Year,
            writeOptions: {}
        }

        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })

        let dataA = [
            {
                sheet: 'BL Arrears Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const getPageMargins = () => {
        return `@media print {
        @page {
            background-color: white !important;
            size: A3 Landscape !important;
        }
        body {
            background-color: white !important;
        }
    }`;
    };

    const getUniqueRouteIDs = (data) => {
        return [...new Set(data.map(item => item.routeID))];
    };

    return (
        <Fragment>
            <LoadingComponent />
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Box mt={3}>
                        <Card>
                            <CardHeader title="Arrears Report" />
                            <Formik
                                initialValues={{
                                    groupID: arrearsReportInput.groupID,
                                    factoryID: arrearsReportInput.factoryID,
                                    routeID: arrearsReportInput.routeID,
                                }}
                                validationSchema={Yup.object().shape({
                                    groupID: Yup.number().required("Group is required").min(1, "Group is required"),
                                    factoryID: Yup.number().required("Factory is required").min(1, "Factory is required"),
                                    routeID: Yup.number(),
                                })}
                                onSubmit={handleSearch}
                                enableReinitialize
                            >
                                {({ errors, handleBlur, handleSubmit, touched }) => (
                                    <form onSubmit={handleSubmit}>
                                        <Divider />
                                        <CardContent>
                                            <Grid container spacing={3}>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                                    <TextField
                                                        select
                                                        error={Boolean(touched.groupID && errors.groupID)}
                                                        fullWidth
                                                        helperText={touched.groupID && errors.groupID}
                                                        name="groupID"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={arrearsReportInput.groupID}
                                                        variant="outlined"
                                                        id="groupID"
                                                        size="small"
                                                        disabled={!permissionList.isGroupFilterEnabled}
                                                    >
                                                        <MenuItem value={0}>--Select Group--</MenuItem>
                                                        {generateDropDownMenu(groups)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                                    <TextField
                                                        select
                                                        error={Boolean(touched.factoryID && errors.factoryID)}
                                                        fullWidth
                                                        helperText={touched.factoryID && errors.factoryID}
                                                        name="factoryID"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={arrearsReportInput.factoryID}
                                                        variant="outlined"
                                                        id="factoryID"
                                                        size="small"
                                                        disabled={!permissionList.isFactoryFilterEnabled}
                                                    >
                                                        <MenuItem value={0}>--Select Factory--</MenuItem>
                                                        {generateDropDownMenu(factories)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <InputLabel shrink id="routeID">Route</InputLabel>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        name="routeID"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={arrearsReportInput.routeID}
                                                        variant="outlined"
                                                        id="routeID"
                                                        size="small"
                                                    >
                                                        <MenuItem value={0}>--All Routes--</MenuItem>
                                                        {generateDropDownMenu(routes)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <DatePicker
                                                            autoOk
                                                            variant="inline"
                                                            openTo="month"
                                                            views={["year", "month"]}
                                                            label="Year and Month *"
                                                            helperText="Select applicable month"
                                                            value={selectedDate}
                                                            onChange={handleDateChange}
                                                            size="small"
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Grid>
                                            </Grid>
                                            <Box display="flex" justifyContent="flex-end" mt={2}>
                                                <Button color="primary" variant="contained" type="submit" size="small">Search</Button>
                                            </Box>
                                        </CardContent>
                                    </form>
                                )}
                            </Formik>
                            <Box mt={3}>
                                {arrearsReportData.length > 0 && (
                                    <Box>
                                        {arrearsReportData &&
                                            getUniqueRouteIDs(arrearsReportData).sort((a, b) => routes[a].localeCompare(routes[b])).map((routeID) => {
                                                const routeData = arrearsReportData.filter((d) => d.routeID === routeID);
                                                const totalNetWeight = routeData.reduce((sum, d) => sum + Number(d.netWeight || 0), 0);
                                                const totalGrossPay = routeData.reduce((sum, d) => sum + Number(d.grossPay || 0), 0);
                                                const totalAddition = routeData.reduce((sum, d) => sum + Number(d.addition || 0), 0);
                                                const totalBroughtForwardDept = routeData.reduce((sum, d) => sum + Number(d.broughtForwardDept || 0), 0);
                                                const totalFertBroughtForward = routeData.reduce((sum, d) => sum + Number(d.fertBroughtForward || 0), 0);
                                                const totalFAdv = routeData.reduce((sum, d) => sum + Number(d.fAdv || 0), 0);
                                                const totalAdvance = routeData.reduce((sum, d) => sum + Number(d.advance || 0), 0);
                                                const totalTeaBagTotalSpent = routeData.reduce((sum, d) => sum + Number(d.teaBagTotalSpent || 0), 0);
                                                const totalFertilizerTotalSpent = routeData.reduce((sum, d) => sum + Number(d.fertilizerTotalSpent || 0), 0);
                                                const totalChemicalTotalSpent = routeData.reduce((sum, d) => sum + Number(d.chemicalTotalSpent || 0), 0);
                                                const totalMealTotalSpent = routeData.reduce((sum, d) => sum + Number(d.mealDeduction || 0), 0);
                                                const totalLoan = routeData.reduce((sum, d) => sum + Number(d.loan || 0), 0);
                                                const totalOther = routeData.reduce((sum, d) => sum + Number(d.other || 0), 0);
                                                const totalTotalDeduction = routeData.reduce((sum, d) => sum + Number(d.totalDeduction || 0), 0);
                                                const totalArrears = routeData.reduce((sum, d) => sum + Number(d.arrears || 0), 0);

                                                return (
                                                    <Fragment key={routeID}>
                                                        <Typography
                                                            variant="h5"
                                                            style={{ fontWeight: "bold", paddingLeft: '16px', marginBottom: 10 }}
                                                        >
                                                            Route: {routes[routeID]}
                                                        </Typography>
                                                        <TableContainer component={Paper} style={{ marginBottom: 20, maxWidth: '100%', overflowX: 'auto', paddingRight: '16px' }}>
                                                            <Table style={{ tableLayout: "fixed", minWidth: "100%", width: 'max-content', margin: 'auto' }}>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Sup ID</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold', width: '200px' }}>Sup Name</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Tot. KG</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>GrossPay</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>ADD</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>B/F Debt</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Fert B/F</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>F.Adv</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Advance</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Tea</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Fertilizer</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Chemical</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Meals</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Loan</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Other</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Tot.Deduct</TableCell>
                                                                        <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Arrears</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {routeData.map((data, index) => (
                                                                        <TableRow key={index}>
                                                                            <TableCell align="center" style={{ padding: '2px' }}>{data.registrationNumber}</TableCell>
                                                                            <TableCell align="left" style={{ padding: '2px', width: '200px' }}>{data.name}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.netWeight}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.grossPay.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.addition.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.broughtForwardDept.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.fertBroughtForward.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.fAdv.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.advance.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.teaBagTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.fertilizerTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.chemicalTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.mealDeduction.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.loan.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.other.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{data.totalDeduction.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align="right" style={{ padding: '2px' }}>{Math.abs(data.arrears).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                                <TableRow>
                                                                    <TableCell colSpan={2} align="left" style={{ paddingLeft: '16px', fontWeight: 'bold' }}>Total :</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalNetWeight.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalGrossPay.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalAddition.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalBroughtForwardDept.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalFertBroughtForward.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalFAdv.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalAdvance.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalTeaBagTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalFertilizerTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalChemicalTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalMealTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalLoan.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalOther.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{totalTotalDeduction.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ padding: '2px', fontWeight: 'bold' }}>{Math.abs(totalArrears).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                </TableRow>
                                                            </Table>
                                                                {routeID === getUniqueRouteIDs(arrearsReportData).sort((a, b) => routes[a].localeCompare(routes[b]))[getUniqueRouteIDs(arrearsReportData).length - 1] ?
                                                                    <Table style={{marginTop: '24px'}}>
                                                                        <TableRow>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}></TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Tot. KG</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>GrossPay</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>ADD</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>B/F Debt</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Fert B/F</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>F.Adv</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Advance</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Tea</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Fertilizer</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Chemical</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Meals</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Loan</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Other</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Tot.Deduct</TableCell>
                                                                            <TableCell align={'center'} style={{ fontWeight: 'bold' }}>Arrears</TableCell>
                                                                        </TableRow>
                                                                        <TableRow>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>Grand Total :</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalNetWeight.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalGrossPay.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalAddition.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalBroughtForwardDept.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalFertBroughtForward.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalFAdv.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalAdvance.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalTeaBagTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalFertilizerTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalChemicalTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalMealTotalSpent.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalLoan.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalOther.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{grandTotal.totalTotalDeduction.toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                            <TableCell align={'center'} style={{ padding: '2px', fontWeight: 'bold' }}>{Math.abs(grandTotal.totalArrears).toLocaleString("en-US", { minimumFractionDigits: 2 })}</TableCell>
                                                                        </TableRow>
                                                                    </Table> : null
                                                                }
                                                        </TableContainer>
                                                    </Fragment>)
                                            })}
                                        <Box display='flex' justifyContent='flex-end' p={2}>
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                style={{ marginRight: '1rem' }}
                                                className={classes.colorRecord}
                                                onClick={createFile}
                                            >
                                                EXCEL
                                            </Button>
                                            <ReactToPrint
                                                documentTitle={'BL Arrears Report' + ' - ' + selectedSearchValues.GroupName + ' - ' + selectedSearchValues.FactoryName + ' - ' + selectedSearchValues.RouteName
                                                    + ' - ' + selectedSearchValues.Month + ' ' + selectedSearchValues.Year}
                                                trigger={() => (
                                                    <Button
                                                        color="primary"
                                                        id="btnRecord"
                                                        type="button"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        className={classes.colorCancel}
                                                        size="small"
                                                    >
                                                        PDF
                                                    </Button>
                                                )}
                                                pageStyle={getPageMargins()}
                                                content={() => componentRef.current}
                                            />
                                            <div hidden={true}>
                                                <CreatePDF
                                                    ref={componentRef}
                                                    arrearsReportData={arrearsReportData}
                                                    selectedSearchValues={selectedSearchValues}
                                                    routes={routes}
                                                    grandTotal={grandTotal}
                                                />
                                            </div>
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                        </Card>
                    </Box>
                </Container>
            </Page>
        </Fragment>
    );
}